















































































import { IRequisition, IUser, User } from '@/models';
import { ErrorManager } from '@/models/error';
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'RequisitionBuyerListMenu',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      buyerLoading: false,
      buyerDialog: false,
      errorMessage: '',
      // assign the current buyer to requisition buyer
      buyer: null as null | number | IUser
    };
  },

  watch: {
    buyerDialog(value: boolean) {
      if (value == true) {
        if (this.requisition.buyer) {
          this.buyer = this.requisition.buyer;
        }
      }
    }
  },

  methods: {
    ...mapActions({
      assignRequisitionBuyer: 'requisition/assignRequisitionBuyer'
    }),

    clearAllErrors() {
      this.errorMessage = '';
    },

    closeDialog() {
      this.clearAllErrors();
      this.buyerLoading = false;
      this.buyerDialog = false;
    },

    setRequisitionBuyer(buyer: IUser | number) {
      this.clearAllErrors();
      this.buyerLoading = true;

      const buyerId = buyer instanceof User ? buyer.id : buyer;

      this.assignRequisitionBuyer({
        requisitionId: this.requisition.id,
        buyer: buyerId
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(error => {
          if (error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          } else {
            this.errorMessage = ErrorManager.extractApiError(error);
          }
        })
        .finally(() => {
          this.buyerLoading = false;
        });
    }
  }
});
